import {Injectable} from '@angular/core';
import {environment} from "@environment";

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor() {
  }

  getNetwork() {
    const domain = window.location.hostname;
    if (domain === environment.sm_domain) {
      return 'sm'
    } else if (domain === environment.mm_domain) {
      return 'mm'
    } else if (domain === environment.tg_domain) {
      return 'tg'
    } else {
      return 'sm';
      // throw 'Invalid network'
    }

  }

  getShop() {
    let shop: any = {};
    if(this.getNetwork() === 'sm'){
      shop.networkName = 'ServiceMaster Clean';
      shop.networkColor = 'blue';
      shop.networkLogo = 'assets/images/smc_logo_process.svg';
      shop.networkUrl = 'https://www.servicemasterclean.co.uk';
      shop.favicon = 'assets/images/sm-favicon.ico';
    }else if(this.getNetwork() === 'mm'){
      shop.networkName = 'Merry Maids';
      shop.networkColor = 'blue';
      shop.networkLogo = 'assets/images/mm-logo-green.png';
      shop.networkUrl = 'https://www.merrymaids.co.uk';
      shop.favicon = 'assets/images/mm-favicon.ico';
    }else if(this.getNetwork() === 'tg'){
      shop.networkName = 'TruGreen';
      shop.networkColor = 'blue';
      shop.networkLogo = 'assets/images/trugeen-logo.png';
      shop.networkUrl = 'https://www.trugreen.co.uk/';
      shop.favicon = '';
    }
    return shop;
  }

  isSM(){
      return this.getNetwork() === 'sm';
  }

  isMM(){
      return this.getNetwork() === 'mm';
  }

}
